import { render, staticRenderFns } from "./CheckoutFooter.html?vue&type=template&id=2bf926af&scoped=true&"
import script from "./CheckoutFooter.ts?vue&type=script&lang=ts&"
export * from "./CheckoutFooter.ts?vue&type=script&lang=ts&"
import style0 from "./CheckoutFooter.scss?vue&type=style&index=0&id=2bf926af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf926af",
  null
  
)

export default component.exports